export const CONSTANTS = {
  HEADER_TEXT: 'CVIS Swap Configuration',
  WARNING_MODAL: {
    HEADER: 'Delete?',
    BODY: 'Delete the User ID',
  },
};

export enum ColumnIds {
  SELECT = 'select',
  ID = 'id',
  NAME = 'name',
  ACTIVE = 'active',
  EFFECTIVE = 'effective',
  EXPIRES = 'expires',
  MON = 'mon',
  TUE = 'tue',
  WED = 'wed',
  THU = 'thu',
  FRI = 'fri',
  SAT = 'sat',
  SUN = 'sun',
  ORIG_CODE = 'origCode',
  ORIG_SORT = 'origSort',
  DEST_SLIC = 'destSlic',
  DEST_SORT = 'destSort',
  SERVICE = 'service',
  SWAP_SLIC = 'swapSlic',
  SWAP_SORT = 'swapSort',
  SWAP_SERVICE = 'swapService',
  SWAP_PKG_LOC_ROLE = 'swapPkgLocRole',
  MON_LCD = 'monLcd',
  TUE_LCD = 'tueLcd',
  WED_LCD = 'wedLcd',
  THU_LCD = 'thuLcd',
  FRI_LCD = 'friLcd',
  SAT_LCD = 'satLcd',
  SUN_LCD = 'sunLcd',
}

export const ColumnText = {
  ID: $localize`Id`.toUpperCase(),
  NAME: $localize`Name`.toUpperCase(),
  ACTIVE: $localize`Active`.toUpperCase(),
  EFFECTIVE: $localize`EFF DT`.toUpperCase(),
  EXPIRES: $localize`EXP DT`.toUpperCase(),
  MON: $localize`MO`.toUpperCase(),
  TUE: $localize`TU`.toUpperCase(),
  WED: $localize`WE`.toUpperCase(),
  THU: $localize`TH`.toUpperCase(),
  FRI: $localize`FR`.toUpperCase(),
  SAT: $localize`SA`.toUpperCase(),
  SUN: $localize`SU`.toUpperCase(),
  ORIG_CODE: $localize`ORIG CODE`.toUpperCase(),
  ORIG_SORT: $localize`ORIG SORT`.toUpperCase(),
  DEST_SLIC: $localize`DEST SLIC`.toUpperCase(),
  DEST_SORT: $localize`DEST SORT`.toUpperCase(),
  SERVICE: $localize`SVC`.toUpperCase(),
  SWAP_SLIC: $localize`SWAP SLIC`.toUpperCase(),
  SWAP_SORT: $localize`SWAP SORT`.toUpperCase(),
  SWAP_SERVICE: $localize`SWAP SVC`.toUpperCase(),
  SWAP_PKG_LOC_ROLE: $localize`SWAP LOC ROLE`.toUpperCase(),
  MON_LCD: $localize`MO LCD`.toUpperCase(),
  TUE_LCD: $localize`TU LCD`.toUpperCase(),
  WED_LCD: $localize`WE LCD`.toUpperCase(),
  THU_LCD: $localize`TH LCD`.toUpperCase(),
  FRI_LCD: $localize`FR LCD`.toUpperCase(),
  SAT_LCD: $localize`SA LCD`.toUpperCase(),
  SUN_LCD: $localize`SU LCD`.toUpperCase(),
};

export const EXCEL_HEADERS = [
  'ID',
  'NAME',
  'ACTIVE',
  'EFF DT',
  'EXP DT',
  'MO',
  'TU',
  'WE',
  'TH',
  'FR',
  'SA',
  'SU',
  'ORIG CODE',
  'ORIG SORT',
  'DEST SLIC',
  'DEST SORT',
  'SVC',
  'SWAP SLIC',
  'SWAP SORT',
  'SWAP SVC',
  'MO LCD',
  'TU LCD',
  'WE LCD',
  'TH LCD',
  'FR LCD',
  'SA LCD',
  'SU LCD',
];

export const FILE_NAME = `cvis-swap`;

export const SORT_INDICATOR_MAP: { [key: string]: string } = {
  '01': 'S',
  '02': 'M',
  '03': 'D',
  '04': 'T',
  '05': 'N',
  '06': 'P',
  '07': 'L',
  '08': 'A',
};

export const SERVICE_CODE_MAP: { [key: string]: string } = {
  '001': '1DA',
  '002': '2DA',
  '012': '3DS',
  '014': 'EAM',
  '004': 'GND',
};

export const REVERSE_SORT_INDICATOR_MAP: { [key: string]: string } = {
  S: '01',
  M: '02',
  D: '03',
  T: '04',
  N: '05',
  P: '06',
  L: '07',
  A: '08',
};

export const REVERSE_SERVICE_CODE_MAP: { [key: string]: string } = {
  '1DA': '001',
  '2DA': '002',
  '3DS': '012',
  EAM: '014',
  GND: '004',
};
